import { Skeleton, Stack } from '@mantine/core';

import { FullMainHeight } from '@ui';

export function ContractDetailsPageSkeleton() {
  return (
    <FullMainHeight.Root>
      <FullMainHeight.FlexContent>
        <FullMainHeight.Sidebar>
          <Stack h="100%">
            <Skeleton h={60} />
            <Skeleton h={100} />
            <Skeleton h={200} />
            <Skeleton h={70} />
          </Stack>
        </FullMainHeight.Sidebar>
        <Skeleton h="100%" />
      </FullMainHeight.FlexContent>
    </FullMainHeight.Root>
  );
}
